import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Layout from "../../Components/layouts";
import { notify } from '../../utils';
import { useHistory, useParams } from "react-router-dom";
import { REQUIRED_ERROR, USER_ROLES } from '../../utils/constants';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { UserServices } from '../../Services/UserServices';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Paths } from '../../Routes/routePaths';
import { ProjectServices } from '../../Services/ProjectServices';
import { FormControlLabel, Switch } from '@material-ui/core';
import { useAuthDispatch, useAuthState } from '../../Context';
import variables from '../../Sys/variable.scss';
import commonStyles from 'theme/commonStyles';
import CreateUserForm from './components/CreateUserForm';
import { useEffect } from 'react';

const userServices = new UserServices();
const projectService = new ProjectServices();

const useStyles = makeStyles((theme) => ({
    inputStyle: {
        borderColor: '#838383',
        borderRadius: '25px',
    },
    pageHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        margin: '25px 0'
    },
    heading: {
        color: variables.labelcolor,
        fontSize: '23px',
        fontWeight: '500'
    },
    btn: {
        padding: '13px 35px',
        fontSize: '13px',
        color: 'white',
        borderRadius: '5px',
        marginLeft: '15px',
    },
    cancelBtn: {
        padding: '13px 35px',
        background: '#B7B7B7',
        fontSize: '13px',
        color: 'white',
        borderRadius: '5px',
        marginLeft: '15px',
        "&:hover": {
            background: "#454343"
        }
    },
    placeBtn: {
        display: 'flex',
        justifyContent: 'end',
        padding: '20px 0',
        marginTop: 30
    },
    btnPwd: {
        borderRadius: '25px',
        padding: 16,
        top: 0,
        left: 177,
        position: 'absolute'
    },
}));

const initFormState = {
    firstName: '',
    lastName: '',
    userName: '',
    email: '',
    location: '',
    customers: [],
    role: '',
    is_active: false,
    password: '',
    sub_role: '',
    project: null
};

const UpdateUsers = () => {

    const dispatch = useAuthDispatch();
    const { userDetails } = useAuthState(dispatch);
    const history = useHistory();

    const { id } = useParams();
    const classes = useStyles();
    const commonClasses = commonStyles();
    const [companyList, setCompanyList] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [customers, setCustomers] = React.useState([]);
    const [formState, setFormState] = React.useState({ ...initFormState });
    const [roleList, setRoleList] = React.useState([]);
    const [projectList, setProjectList] = React.useState([]);
    const [editUserData, setEditUserData] = React.useState(null);

    React.useEffect(() => {
        if (id) {
            getProjectList();
        }
    }, []);

    const getProjectList = async () => {
        const projectRes = await projectService.getAllLicenseListProject(`project/licenselist`);
        if (projectRes && projectRes.data && projectRes.data.length > 0) {
            const allProject = projectRes.data.map(item => {
                return {
                    name: item.project_name,
                    id: item.project_uuid
                }
            });
            setProjectList(allProject);
        }
        getUserDetails();
    };

    useEffect(() => {
        if (editUserData) {
            const selectedProj = projectList.find(p => p.id === editUserData.project_id);
            setFormState({
                firstName: editUserData.firstName,
                lastName: editUserData.lastName,
                userName: editUserData.userName,
                email: editUserData.email,
                customers: editUserData.customers,
                location: editUserData.location,
                role: editUserData.role,
                project: selectedProj ? { name: selectedProj.name, id: selectedProj.id } : null,
                is_active: editUserData.is_active
            });
        }
    }, [projectList, editUserData]);

    async function getUserDetails() {
        const cusResult = await projectService.getCustomerList();
        if (cusResult && cusResult.data) {
            setCompanyList(cusResult.data);
        }
        let data = await userServices.getUserDetail(id);
        if (data && data.status) {
            const userData = data.data[0];
            setEditUserData(userData);
            if (userData?.customers?.length) {
                const selectedComp = cusResult.data ? cusResult.data.filter(cs => userData.customers.includes(cs.uuid)) : [];
                setCustomers(selectedComp);
            }
        }
    }

    React.useEffect(() => {
        const { role } = userDetails;
        let roles = [];
        if (role === USER_ROLES.SUPER_ADMIN) {
            roles = [{
                id: 'customeradmin',
                name: 'Customer Admin'
            },
            {
                id: 'csmadmin',
                name: 'CSM'
            }];
        }
        if (['customeradmin', 'superadmin'].includes(role)) {
            roles.push({
                id: 'projectadmin',
                name: 'Project Admin'
            });
            roles.push({ id: 'gcologist', name: 'GCologist' });
        }
        roles.push({
            id: 'user',
            name: 'User'
        });
        setRoleList(roles);
    }, [userDetails]);

    const handleInputChange = (evt) => {
        const { name, value } = evt.target;
        if (name === 'email') {
            setFormState({ ...formState, email: value, userName: value });
        } else {
            setFormState({ ...formState, [name]: value });
        }
    }

    const handleChange = (event) => {
        setFormState({ ...formState, [event.target.name]: event.target.checked });
    };

    const formValidationCheck = () => {
        if (!formState.firstName || !formState.lastName || !formState.userName || !formState.email || !formState.location) {
            notify("error", REQUIRED_ERROR);
            return null;
        }
        return handleFormSubmit();
    }

    const handleFormSubmit = async () => {
        setLoading(true);
        let customersIds = customers.map(cs => cs.uuid);
        const payload = { 
            ...formState, 
            userName: formState.email,
            customers: customersIds, 
            project_id: (formState.project) ? formState.project.id : null 
        };
        delete payload.project;
        const result = await userServices.addUser(payload, id);
        if (result && result.status) {
            notify("success", result.message)
            setLoading(false);
            history.push(Paths.Users);
        } else {
            notify("error", (result && result.message) ? result.message : 'Something Went Wrong')
            setLoading(false)
        }
    }

    const handleChangeCustomer = (newValue, type) => {
        if (type === 'project') {
            setFormState({ ...formState, project: newValue });
        } else {
            setCustomers(newValue);
        }
    }

    const generatePassword = evt => {
        evt.preventDefault();
        let newPwd = '';
        const pwdChars =
            'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890*/&%$#@!';
        for (let i = 0; i < 8; i++) {
            newPwd += pwdChars[Math.floor(Math.random() * pwdChars.length)];
        }
        if (newPwd) {
            setFormState({ ...formState, password: newPwd });
        }
    };

    return (
        <Layout>
            <main>
                <div className={commonClasses.contentWrapper}>
                    <div className={classes.pageHeader}>
                        <Typography
                            variant="subtitle2"
                            className={classes.heading}
                            color="textPrimary">
                            Update User
                        </Typography>
                        <FormControlLabel
                            control={<Switch checked={formState.is_active} onChange={handleChange} name="is_active" />}
                            label="Account Status"
                        />
                    </div>
                    <CreateUserForm
                        projectList={projectList}
                        formState={formState}
                        handleChangeCustomer={handleChangeCustomer}
                        handleInputChange={handleInputChange}
                        companyList={companyList}
                        roleList={roleList}
                        userDetails={userDetails}
                        customers={customers}
                        emailDisable
                        userNameDisable
                        showProject
                        showPassword
                        onGeneratePassword={generatePassword}
                    />
                    <div className={classes.placeBtn}>
                        <Button onClick={() => history.push(Paths.Users)} className={classes.cancelBtn}>
                            Cancel
                        </Button>
                        <Button
                            color="primary"
                            className={classes.btn}
                            variant="outlined"
                            disabled={
                                !formState.firstName ||
                                !formState.lastName ||
                                !formState.userName ||
                                !formState.email ||
                                !formState.role ||
                                !formState.location
                            }
                            onClick={formValidationCheck}>
                            {loading ? <CircularProgress size={15} color="secondary" /> : 'Save'}
                        </Button>
                    </div>
                </div>
            </main>
        </Layout>
    );
}

export default UpdateUsers;